import { computed } from 'vue';
import { get, isEmpty, mapValues, omit, omitBy } from 'lodash-es';

export const useOptions = (props) => {
  const options = computed(() =>
    mapValues(props.config.options, (option) => {
      const price = get(option, ['prices', window.Phoenix.currentCountry], {});

      const items = mapValues(option.items, (item) => {
        const price = get(item, ['prices', window.Phoenix.currentCountry], {});

        return omit(
          {
            ...item,
            ...price,
            sublabel: item.sublabel ?? price.formattedFromPrice ?? '',
          },
          ['prices'],
        );
      });

      return omit(
        {
          ...option,
          ...price,
          items,
        },
        ['prices'],
      );
    }),
  );

  const formattedOptions = computed(() =>
    omitBy(
      mapValues(options.value, (option) => option.items),
      isEmpty,
    ),
  );

  const getOptionParam = (option, param, defaultValue = null) => options.value[option]?.[param] ?? defaultValue;

  // eslint-disable-next-line max-params
  const getOptionItemParam = (option, item, param, defaultValue = null, fallbackToParent = false) =>
    options.value[option]?.items[item]?.[param] ??
    (fallbackToParent ? getOptionParam(option, param, defaultValue) : defaultValue);

  return {
    options,
    formattedOptions,
    getOptionParam,
    getOptionItemParam,
  };
};
